// Nombre seguro para la ruta en Storage (bloque 5b, A). Supabase rechaza con
// "Invalid key" las rutas con tildes, ñ y algunos símbolos, así que toda subida
// arma la ruta con esta función. El nombre original (el que ve el usuario) se
// sigue guardando aparte, en file_name o attachment_name.

const MAX_NOMBRE = 100;

function limpiar(texto: string): string {
  return texto
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/ñ/g, 'n').replace(/Ñ/g, 'N')
    .replace(/[^A-Za-z0-9._-]/g, '-')
    .replace(/-{2,}/g, '-');
}

/**
 * "Política Señalización Comité.pdf" → "Politica-Senalizacion-Comite.pdf".
 * Sin tildes ni ñ; espacios y cualquier carácter fuera de [A-Za-z0-9._-] → "-";
 * sin guiones repetidos; extensión en minúsculas; 100 caracteres como máximo.
 * Nunca devuelve una cadena vacía ni una "/".
 */
export function nombreSeguroStorage(nombre: string): string {
  const punto = nombre.lastIndexOf('.');
  const tieneExt = punto > 0 && punto < nombre.length - 1;
  const ext = tieneExt ? limpiar(nombre.slice(punto + 1)).replace(/[^A-Za-z0-9]/g, '').toLowerCase().slice(0, 10) : '';
  const sufijo = ext ? `.${ext}` : '';

  let base = limpiar(tieneExt ? nombre.slice(0, punto) : nombre).replace(/^[-.]+|[-.]+$/g, '');
  base = base.slice(0, MAX_NOMBRE - sufijo.length).replace(/[-.]+$/, '');
  return (base || 'archivo') + sufijo;
}
